/* RESPONSIBLE TEAM: team-workflows */
import ConditionalBranches from 'embercom/models/operator/visual-builder/step/conditional-branches';
import type Store from '@ember-data/store';

export default class EscalationRuleTriggered extends ConditionalBranches {
  static createNewStep(store: Store): EscalationRuleTriggered {
    let predicateGroup = store.createFragment('predicates/predicate-group');
    let guidanceAppliedPredicate = store.createFragment('predicates/optional-select', {
      attribute: 'conversation.guidance_applied',
      comparison: 'in',
      type: 'guidance_applied',
    });

    let options = guidanceAppliedPredicate.get('options');
    let defaultValue = options?.get('firstObject.value');

    if (defaultValue) {
      guidanceAppliedPredicate.set('value', defaultValue);
    } else {
      guidanceAppliedPredicate.set('comparison', 'known');
    }

    predicateGroup.predicates.pushObject(guidanceAppliedPredicate);

    let condition = store.createRecord('operator/visual-builder/connection-point', {
      label: null,
      type: 'conditional_branch',
      predicateGroup,
    });

    let elseBranch = store.createRecord('operator/visual-builder/connection-point', {
      label: null,
      type: null,
    });

    return store.createRecord('operator/visual-builder/step/conditional-branches', {
      outwardConnectionPoints: [condition, elseBranch],
      type: 'operator/visual-builder/step/conditional-branches',
    });
  }
}
